import React, { useState } from "react";
import NewFile from "./NewFile";
import FileBoard from "./FileBoard";
import Storage from "../../Data/Domain/Storage";
import {
  getByUser,
  getAll,
} from "../../DocumentUpload/Application/DocumentUpload.business";
import User from "../../Users/Domain/User";
import { CustomCard, Title } from "../../Utils/UI/Text";
import "./Files.css";

const Files = () => {
  const role = new Storage("rol").getItem();
  const user_id = new Storage("id").getItem();
  const [imageCounter, setImageCounter] = useState(0);
  const [description, setDescription] = useState("");
  const MIN_DESCRIPTION_LENGTH = 15;

  const isDescriptionValid =
    description && description.length >= MIN_DESCRIPTION_LENGTH;

  const type = "carbon_management_file";
  const handleImageUpdate = () => {
    setImageCounter(imageCounter + 1);
    setDescription("");
  };
  const handleDescriptionChange = (e) => {
    setDescription(e.target.value);
  };

  return (
    <>
      <Title
        children="Archivos"
        childrenTwo={
          <NewFile
            userId={user_id}
            handleImageUpdate={handleImageUpdate}
            description={description}
            handleDescriptionChange={handleDescriptionChange}
            getByUser={getByUser}
            User={User}
            role={role}
            isDescriptionValid={isDescriptionValid}
            minLength={MIN_DESCRIPTION_LENGTH}
          />
        }
      />
      <CustomCard>
        <FileBoard
          userId={user_id}
          imageCounter={imageCounter}
          getByUser={getByUser}
          role={role}
          User={User}
          getAll={getAll}
          type={type}
        />
      </CustomCard>
    </>
  );
};

export default Files;
